import { useTranslation } from "react-i18next";
import { Parcel } from "@/mocks/parcels";

interface LocationMapProps {
  parcel: Parcel;
}

export default function LocationMap({ parcel }: LocationMapProps) {
  const { t } = useTranslation();

  // Use location name if available, otherwise fall back to coordinates
  const query = parcel.currentLocation
    ? encodeURIComponent(parcel.currentLocation)
    : `${parcel.lat},${parcel.lng}`;
  const mapSrc = `https://maps.google.com/maps?q=${query}&z=12&output=embed&hl=en`;

  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden h-full flex flex-col">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
        <h3 className="font-semibold text-slate-800 text-base">{t("parcel_map_title")}</h3>
        <div className="flex items-center gap-1.5 text-xs text-emerald-600 font-medium">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          Live
        </div>
      </div>

      {/* Map */}
      <div className="flex-1 min-h-[300px] relative">
        <iframe
          title="Parcel Location Map"
          src={mapSrc}
          className="w-full h-full border-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* Location info overlay */}
      <div className="px-5 py-3 bg-slate-50 border-t border-gray-100">
        <div className="flex items-start gap-2">
          <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
            <i className="ri-map-pin-2-fill text-emerald-500 text-sm" />
          </div>
          <div>
            <p className="text-slate-700 text-sm font-medium">{parcel.currentLocation}</p>
            <p className="text-slate-400 text-xs mt-0.5">
              {t("parcel_current_location")} &bull; {parcel.lastUpdated}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
